<div class="modal-content">
  <div class="modal-header">
    <h1
      class="modal-title model-title-align"
      aria-hidden="true"
      id="my-modal-title"
    >
      {{ "APPEAL_AUTH_POP_TITLE" | globalTranslate }}
    </h1>
    <button
      type="button"
      class="btn-close pull-right"
      [attr.aria-label]="'CLOSE' | globalTranslate"
      (click)="onCancel()"
    >
      <img
        src="../../assets/images/⚛️ icons-close-circle-outline.svg"
        alt="close-icon"
      />
    </button>
  </div>
  <div class="modal-body model-body-margin">
    <p
      class="p_font"
      [innerHtml]="'APPEAL_AUTH_POP_DESC1' | globalTranslate | sanitize"
    ></p>
    <br />
    <p
      class="p_font"
      [innerHtml]="'APPEAL_AUTH_POP_DESC2' | globalTranslate | sanitize"
    ></p>
  </div>
  <div class="modal-footer justify-content-center">
    <div class="me-2 ml-2">
      @if (showConfirm) {
      <button
        type="button"
        id="dialog"
        class="btn d-grid btn-secondary"
        (click)="onConfirm()"
        [disabled]="isConfirmDisabled()"
      >
        {{ "OK" | globalTranslate }}
      </button>
      }
    </div>
  </div>
</div>